import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initMercadoPago } from '@mercadopago/sdk-react'
import { getPublicKey } from '@/config/mercadopago'
import { initGTM } from '@/config/gtm'
import './index.css'
import App from './App.jsx'
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://2cd530bc5afcf0ebb9fab46c910a83e3@o4505344083165184.ingest.us.sentry.io/4511230864064512",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

initGTM()
initMercadoPago(getPublicKey())

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
